var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { class: _vm.classes, on: { click: _vm.toggleEditMode } },
    [
      !_vm.editMode
        ? [
            _vm.loading
              ? _c("CompassSkeleton", { attrs: { size: "x-large" } })
              : _c(
                  "div",
                  { staticClass: "edit-simple-date__value" },
                  [
                    _c("CompassIcon", {
                      attrs: { size: "small", icon: "calendar-fill" }
                    }),
                    _vm._v(" "),
                    _c(
                      "span",
                      { staticClass: "typographies-paragraph-medium-regular" },
                      [
                        _vm._v(
                          "\n                " +
                            _vm._s(_vm.formattedDate) +
                            "\n            "
                        )
                      ]
                    )
                  ],
                  1
                )
          ]
        : _c("CompassDatePicker", {
            attrs: {
              value: _vm.localDate,
              formatDateDisplayed: _vm.dateFormat,
              lang: _vm.uiLang,
              calendarOptions: { value: _vm.localDate },
              openCalendar: true
            },
            on: {
              "update:value": _vm.handleValueUpdate,
              close: function($event) {
                _vm.editMode = false
              }
            }
          })
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }